import { render, staticRenderFns } from "./index.vue?vue&type=template&id=10e60e89"
import script from "./customerQueries.js?vue&type=script&lang=js&external"
export * from "./customerQueries.js?vue&type=script&lang=js&external"
import style0 from "./customerQueries.css?vue&type=style&index=0&prod&lang=css&external"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports